module.exports = __webpack_public_path__ + "img/weixin-icon.9d3c2532.svg";